import useSWR from 'swr'
import axios from '@/lib/axios'
import { useEffect } from 'react'
import { useParams, useRouter } from 'next/navigation'
import { ApiRoutes, Routes } from '@/settings/routes'

export const useAuth = ({ middleware, redirectIfAuthenticated } = {}) => {
    const router = useRouter()
    const params = useParams()

    const { data: user, error, isLoading, mutate } = useSWR(ApiRoutes.API_GET_USER, () =>
        axios
            .get(ApiRoutes.API_GET_USER)
            .then(res => res.data)
            .catch(error => {
                
                if (error.response.status !== 409) throw error

                router.push(Routes.DASHBOARD_verify_email)
            }),
    )

    const csrf = () => axios.get(ApiRoutes.API_CSRF_COOKIE);

    const register = async ({field, setErrors, setProcessing }) => {
        await csrf();
        setErrors([]);
        setProcessing(true);

        axios
            .post(ApiRoutes.API_REGISTER, field)
            .then(() => {
                mutate();
                setProcessing(false);
            })
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(error.response.data.errors);
                setProcessing(false);
            })
    }

    const login = async ({field, setErrors, setStatus, setProcessing}) => {
        await csrf();
        setProcessing(true);
        setErrors([]);
        setStatus(null);

        axios
            .post(ApiRoutes.API_LOGIN_URL, field)
            .then(() => {
                mutate();
                setProcessing(true);
            })
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(error.response.data.errors)
                setProcessing(false);
            })
    }

    const forgotPassword = async ({ setErrors, setStatus, email, setProcessing }) => {
        await csrf()

        setErrors([]);
        setStatus(null);
        setProcessing(true);

        axios
            .post(ApiRoutes.API_FORGOT_PASSWORD, { email })
            .then(response => {
                setStatus(response.data.status);
                setProcessing(false);
            })
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(error.response.data.errors);
                setProcessing(false);
            })
    }

    const resetPassword = async ({ field, setErrors, setStatus, setProcessing}) => {
        await csrf();

        setErrors([]);
        setStatus(null);
        setProcessing(true);

        axios
            .post(ApiRoutes.API_RESET_PASSWORD, field)
            .then(response => {
                setProcessing(false);
                router.push('/login?reset=' + btoa(response.data.status))
            })
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(error.response.data.errors);
                setProcessing(false);
            })
    }

    const resendEmailVerification = ({ setStatus, setProcessing }) => {
        setProcessing(true);
        axios
            .post(ApiRoutes.API_EMAIL_VEREFICATION)
            .then(response => {
                setProcessing(false);
                setStatus(response.data.status)
            });
    }

    const logout = async () => {
        if (!error) {
            await axios.post(ApiRoutes.API_LOGOUT).then(() => mutate())
        }

        window.location.pathname = Routes.DASHBOARD_login
    }

    useEffect(() => {
        if (middleware === 'guest' && redirectIfAuthenticated && user)
            router.push(redirectIfAuthenticated)
        if (
            window.location.pathname === Routes.DASHBOARD_verify_email &&
            user?.email_verified_at
        )
            router.push(redirectIfAuthenticated)
        if (middleware === 'auth' && error) logout()
    }, [user, error])

    return {
        user,
        csrf,
        isLoading,
        register,
        login,
        forgotPassword,
        resetPassword,
        resendEmailVerification,
        logout,
    }
}
